import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { errorStatusHandle } from "../utils/error-utils";
import {
  getMachineUrl,
  getInitialMachineDataSort,
  getOriginalData
} from "../services/MachineServices";
import { getMachines } from "../api/machine/machineUpdateApi";
import {
  clearComponentLoading,
  setComponentLoading,
  setUpdateMachineBatchAlertError,
  setButtonProcessing,
  clearButtonProcessing,
} from "../store/actions";
import { BUTTON_FILTER_MACHINE_UPDATE } from "../constants/buttons";
import _ from "lodash";

const useGetMachines = () => {
  const dispatch = useDispatch();
  const [errors, setErrors] = useState({});
  const [filterData, setFilterData] = useState({});
  const [getMachineData, setGetMachineData] = useState({});
  const [initialDataSort, setInitialDataSort] = useState([]);
  const [reload, setReload] = useState(0);
  const [originalData, setOriginalData] = useState([]);

  useEffect(() => {
    dispatch(setComponentLoading("machine_update"));
    if (reload) {
      dispatch(setButtonProcessing(BUTTON_FILTER_MACHINE_UPDATE));
      getMachines(getMachineUrl(getMachineData))
        .then((response) => {
          const data = response.data
          const initData = getInitialMachineDataSort(data)
          setOriginalData(getOriginalData(initData));
          setInitialDataSort(_.cloneDeep(initData))
        })
        .catch((error) => {
          errorStatusHandle(error);
          if (error.status === 400) {
            let responseData = error.data;
            dispatch(setUpdateMachineBatchAlertError(responseData));
            setErrors(error.data.errors);
          }
        })
        .finally(() => {
          dispatch(clearComponentLoading("machine_update"));
          if (reload) {
            dispatch(clearButtonProcessing(BUTTON_FILTER_MACHINE_UPDATE));
          }
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reload]);

  return {
    errors,
    filterData,
    initialDataSort,
    reload,
    originalData,
    setErrors,
    setFilterData,
    setInitialDataSort,
    setReload,
    setGetMachineData
  };
};

export { useGetMachines };
